import { CAlert } from "@coreui/react";
import React from "react";

import roles from "../../constants/roles";
import { useAuth } from "../../providers/auth";

const DashAlert = props => {
  const { user } = useAuth();
  const userRole = user.group_id;

  const [visible, setVisible] = React.useState(true);

  return (
    (userRole == roles.DIRETORIA || userRole == roles.GERENCIA) && (
      <div className="ml-20 mr-20 mt-20">
      <CAlert color="light" dismissible visible={visible} onClose={() => setVisible(false)}>
        <span>Olá, {user.name}! Seja bem vindo! Essa página contém as informações sobre os chats, clientes e vendedores.</span>
      </CAlert>
      </div>
    )
  );
}

export default DashAlert;